<div class="dialog">
  <h2 mat-dialog-title>
    <b>{{ dialogData.title }}</b>
  </h2>
  <div class="dialog-content">
    <mat-dialog-content>
      <div>
        <span class="input-title">{{ dialogData.inputTitle }}</span>
        <mat-form-field class="dialog-input">
          <input
            matInput
            placeholder="{{ dialogData.inputPlaceholder }}"
            [formControl]="stationName"
          />
        </mat-form-field>
      </div>
    </mat-dialog-content>
    <mat-dialog-actions>
      <button mat-button (click)="onCancel()" class="cancel-btn">
        {{ dialogData.cancelButtonText }}
      </button>
      <button
        mat-button
        cdkFocusInitial
        [mat-dialog-close]="stationName.value"
        class="confirm-btn"
      >
        {{ dialogData.confirmButtonText }}
      </button>
    </mat-dialog-actions>
  </div>
</div>
